import { Tracker } from 'services/tracking';
import { getHostedPageFlowType } from 'utilities/global';
import { GA_ACTIONS, GA_CATEGORIES } from 'consts';

export const trackCSSInjection = ({ customStyles }) => {
  const tracker = new Tracker(getHostedPageFlowType());

  tracker.fireEvent({
    category: GA_CATEGORIES.URL_CSS_INJECTION,
    action: GA_ACTIONS.DETECTED,
    label: typeof customStyles === 'string' ? customStyles : JSON.stringify(customStyles)
  });
};
